export function scrollUp(){
  window.scrollTo(0, 0);
}
